import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { InboxPage, type InboxSearch } from "@/features/helpdesk/inbox-page";
import { ensureElementVisible } from "@/lib/route-guards";

// Filtry skrzynki w URL-u (F5 i link wracają do tego samego widoku). Zły
// parametr ze starego linku = wartość domyślna, nie ZodError.
const searchSchema = z.object({
	// `all` bez przycisku: widok Spam i link z wyszukiwarki.
	status: z.enum(["mine", "open", "closed", "all"]).optional().catch(undefined),
	// Lista kategorii po przecinku (`?category=robaczek` z dawnego issue-resolve).
	category: z.string().optional().catch(undefined),
	unpaired: z.boolean().optional().catch(undefined),
	spam: z.boolean().optional().catch(undefined),
	idfirm: z.number().int().positive().optional().catch(undefined),
	q: z.union([z.string(), z.number()]).transform(String).optional().catch(undefined),
	// Okienko „Filtry”: typy po przecinku, tylko nowe, wiek w godzinach, reakcja w minutach.
	type: z.string().optional().catch(undefined),
	onlyNew: z.boolean().optional().catch(undefined),
	minAgeH: z.number().positive().optional().catch(undefined),
	minReaction: z.number().positive().optional().catch(undefined),
	label: z.string().max(40).optional().catch(undefined),
});

export const Route = createFileRoute("/_auth/helpdesk/")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(context.queryClient, "sidebar.helpdesk.obsluga", location.pathname);
	},
	validateSearch: (search: Record<string, unknown>): InboxSearch => searchSchema.parse(search),
	component: InboxRoute,
});

function InboxRoute() {
	const search = Route.useSearch();
	const navigate = useNavigate({ from: "/helpdesk/" });
	return (
		<InboxPage
			search={search}
			onSearchChange={(patch) =>
				navigate({ search: (prev) => ({ ...prev, ...patch }), replace: true })
			}
		/>
	);
}
